import React from 'react';
import '../index.css';
import '../pubic/output.css';

import kendrickPhone from "../assets/images/kendrickphone.png"; // Adjust the path if needed
import searchPhone from "../assets/images/searchphone.png"; // Adjust the path if needed
import shoheiPhone from "../assets/images/shoheiphone.png"; // Adjust the path if needed

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonFab,
  IonFabButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonImg,
  IonActionSheet,
} from '@ionic/react';

import { useState, useEffect } from 'react';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function Mockups(){
  
  const isMobile = useIsMobile();

  if(isMobile == true){
    return(<div style={{backgroundImage: "linear-gradient(rgba(255,255,255,1), rgba(237,90,209,1))"}}>
    <IonRow className="ion-align-items-stretch">
      <IonCol sizeXs="12" sizeSm="6" sizeMd="4">
        <div style={{ height: "750px", display: "flex", justifyContent: "center" }}>
          <img
            src={kendrickPhone}
            alt="Kendrick Lamar Grand National Tour Mockup"
            style={{
              maxHeight: "100%",
              width: "auto",
              objectFit: "contain"
            }}
          />
        </div>
      </IonCol>
      <IonCol sizeXs="12" sizeSm="6" sizeMd="4">
        <div style={{ height: "750px", display: "flex", justifyContent: "center" }}>
          <img
            src={shoheiPhone}
            alt="Shohei Ohtani MLB 2025 Season Page Mockup"
            style={{
              maxHeight: "100%",
              width: "auto",
              objectFit: "contain"
            }}
          />
        </div>
      </IonCol>
    </IonRow>
    </div>
    )
  } else {
  return(
    <div style={{backgroundImage: "linear-gradient(rgba(255,255,255,1), rgba(237,90,209,1))"}}>
    <IonRow className="ion-align-items-stretch">
      <IonCol sizeXs="12" sizeSm="6" sizeMd="4">
        <div style={{ height: "750px", display: "flex", justifyContent: "center" }}>
          <img
            src={kendrickPhone}
            alt="Kendrick Lamar Grand National Tour Mockup"
            style={{
              maxHeight: "100%",
              width: "auto",
              objectFit: "contain"
            }}
          />
        </div>
      </IonCol>
      <IonCol sizeXs="12" sizeSm="6" sizeMd="4">
        <div style={{ height: "750px", display: "flex", justifyContent: "center" }}>
          <img
            src={searchPhone}
            alt="Search Page Mockup"
            style={{
              maxHeight: "100%",
              width: "auto",
              objectFit: "contain"
            }}
          />
        </div>
      </IonCol>
      <IonCol sizeXs="12" sizeSm="6" sizeMd="4">
        <div style={{ height: "750px", display: "flex", justifyContent: "center" }}>
          <img
            src={shoheiPhone}
            alt="Shohei Ohtani MLB 2025 Season Page Mockup"
            style={{
              maxHeight: "100%",
              width: "auto",
              objectFit: "contain"
            }}
          />
        </div>
      </IonCol>
    </IonRow>
    </div>
    )
  }
}
